import "core-js/modules/es.array.concat";
import "core-js/modules/es.array.filter";
import "core-js/modules/es.array.for-each";
import "core-js/modules/es.number.to-fixed";
import "core-js/modules/es.object.to-string";
import "core-js/modules/web.dom-collections.for-each";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:/work/admin/sdk_manage_web/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { popUp } from "@/mixins/index";
import { packageData } from "@/mixins/index";
import uploadAPK from '@/components/uploadAPK';
import util from '@/libs/util';
import axios from 'axios';
export default {
  mixins: [popUp, packageData],
  components: {
    uploadAPK: uploadAPK
  },
  data: function data() {
    return {
      reqLoading: false,
      dialogFormVisible: false,
      formData: {
        file_desc: "",
        download_url: ''
      },
      formDataParams: null,
      isReWrite: false,
      formDataPrimitive: {},
      formDataMake: {},
      fileList: [],
      rules: {
        file_desc: [{
          required: true,
          message: "请输入文件描述",
          trigger: "blur"
        }],
        download_url: [{
          required: true,
          message: "请上传文件地址",
          trigger: "blur"
        }]
      }
    };
  },
  created: function created() {},
  methods: {
    init: function init(data) {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this.fileList = [];
                _this.isReWrite = true;
                _this.dialogFormVisible = true;

              case 3:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    handleExceed: function handleExceed() {
      this.$message.error("\u53EA\u80FD\u4E0A\u4F20\u4E00\u4E2A\u6587\u4EF6!");
    },
    handleChange: function handleChange(file, fileList) {
      this.fileList = fileList;
      console.log("fileList==", this.fileList);
      this.submitUpload();
    },
    // 格式化文件大小（带单位）
    formatFileSize: function formatFileSize(bytes) {
      if (bytes === 0) return '0 Bytes';
      var units = ['Bytes', 'KB', 'MB', 'GB', 'TB'];
      var i = Math.floor(Math.log(bytes) / Math.log(1024));
      return "".concat((bytes / Math.pow(1024, i)).toFixed(2), " ").concat(units[i]);
    },
    handleRemove: function handleRemove(file, fileList) {
      // 从fileList中移除当前文件
      this.fileList = this.fileList.filter(function (item) {
        return item.uid !== file.uid;
      });
    },
    beforeUpload: function beforeUpload(file) {
      var isLt10M = file.size / 1024 / 1024 < 100;

      if (!isLt10M) {
        this.$message.error('上传文件大小不能超过 100MB!');
      }

      return isLt10M;
    },
    submitUpload: function submitUpload() {
      var _this2 = this;

      if (this.fileList.length === 0) {
        this.$message.warning('请先选择文件');
        return;
      }

      var formData = new FormData();
      this.fileList.forEach(function (file) {
        formData.append('file', file.raw);
      });
      var reqFn = "operation/config_upload";
      axios.post(process.env.VUE_APP_API + reqFn, formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
          "Authorization": 'Bearer ' + (util.cookies.get('token') || '')
        }
      }).then(function (res) {
        if (res.data.status == 200) {
          _this2.formData.download_url = res.data.data;

          _this2.$message({
            message: '上传成功',
            type: 'success'
          });
        }
      });
    },
    rewriteClearData: function rewriteClearData() {
      var isClear = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
      this.isReWrite = true;
      this.clearData(isClear);
    },
    clearData: function clearData() {
      var isClear = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
      this.isReWrite = false;
      this.formData = JSON.parse(JSON.stringify(isClear ? this.formDataPrimitive : this.formDataMake));
      this.$refs.ruleForm && this.$refs.ruleForm.clearValidate();
    },
    dataFormSubmit: function dataFormSubmit() {
      var _this3 = this;

      this.$refs.ruleForm.validate( /*#__PURE__*/function () {
        var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(valid) {
          return regeneratorRuntime.wrap(function _callee2$(_context2) {
            while (1) {
              switch (_context2.prev = _context2.next) {
                case 0:
                  if (valid) {
                    _this3.reqLoading = true;

                    _this3.$api.subConfigAdd(_this3.formData).then(function (res) {
                      if (res.status == 200) {
                        _this3.$message({
                          message: '添加成功',
                          type: 'success'
                        });

                        _this3.dialogFormVisible = false;

                        _this3.$emit('change');
                      }
                    }).finally(function () {
                      _this3.reqLoading = false;
                    });
                  }

                case 1:
                case "end":
                  return _context2.stop();
              }
            }
          }, _callee2);
        }));

        return function (_x) {
          return _ref.apply(this, arguments);
        };
      }());
    }
  }
};